import { Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import TextField from "../../../common/TextField";
import { useEffect, useState } from "react";
import Dropdown from "../../../common/DropDown";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { getAllAreas, GetAllproperties, GetAllpropertiesKenket, getAllStates } from "../../../../Services/MMPClientServices/PropertySearchService";
import property from '../../MMPClient/PropertySearch/property.json';
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import { Link } from "react-router-dom";
import { softDeletePropertyService, downloadPropertyExcel } from "../../../../Services/CRMAdminServices/CRMPropertyService";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { CompanyProfile, ContactUsSection, EstateAndSubdivisionImages, Floorplan, Inclusions, RentAppraisal, PackageDownload, PropertyFlyer, StateReport } from "./PropertyFlyer";
import { getAllBuildersService } from "../../../../Services/CRMAdminServices/CRMBuildersService";

import { RootState } from '../../../../ReduxToolkit/Store';
import { useSelector } from 'react-redux';
import { color } from "echarts";
// Utility function to convert image URL to base64
const getBase64FromUrl = async (url: string): Promise<string> => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error converting image to base64:', error);
        return '';
    }
};

export default function CRMPropertySearch() {
    const [propertiesData, setPropertiesData] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState(1);
    // const [pageSize] = useState(20);   // fix 10 at a time
    const [pageSize] = useState(25);

    const [hasMore, setHasMore] = useState(true);
    // const [propertiesData, setPropertiesData] = useState<any>([]);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [pageSize, setPageSize] = useState(10);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [statesData, setStatesData] = useState<any>([]);
    const [suburb, setSuburb] = useState<any[]>([]);
    const [areasData, setAreasData] = useState<any>([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedLeadsId, setCheckedPropertyIds] = useState<any>([])
    const [loading, setLoading] = useState(false);
    const [selectedFlyer, setSelectedFlyer] = useState<any>({})
    const [selectedPackage, setSelectedPackage] = useState<any>({})
    // const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/PropertyImages/`;
    // const [yieldSortOrder, setYieldSortOrder] = useState(""); // "yes", "no", or ""
    const [builders, setBuilders] = useState<any[]>([]);
    const [selectedPropertyId, setSelectedPropertyId] = useState<number | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // Add new state for property details modal
    const [propertyDetailsModal, setPropertyDetailsModal] = useState(false);
    const [selectedPropertyDetails, setSelectedPropertyDetails] = useState<any>(null);

    // Excel upload states
    const [excelUploadModal, setExcelUploadModal] = useState(false);
    const [selectedExcelFile, setSelectedExcelFile] = useState<File | null>(null);
    const [excelUploadLoading, setExcelUploadLoading] = useState(false);
    const [excelResultModal, setExcelResultModal] = useState(false);
    const [excelUploadResults, setExcelUploadResults] = useState<any[]>([]);

    // Excel export states
    const [excelExportModal, setExcelExportModal] = useState(false);
    const [selectedSupplierForExport, setSelectedSupplierForExport] = useState<string>('');
    const [excelExportLoading, setExcelExportLoading] = useState(false);

    const [formData, setFormData] = useState({
        propertyId: '',
        state: '',
        yield: '',
        minimumBed: '',
        maxPrice: '',
        area: '',
        titled: '',
        contractType: '',
        propType: '',
        suburb: '',
        landSize: '',
        houseSize: '',
        supplier: '',
        construction: '',
        propertyKenket: '',

    });

    const handleValueChange = (name: string, value: string | number) => {
        const stringValue = String(value);
        // Clear dependent dropdowns when parent changes
        if (name === 'state') {
            setFormData({ ...formData, [name]: stringValue, area: '', suburb: '' });
            // setAreasData([]);
            // setSuburb([]);
        } else if (name === 'area') {
            setFormData({ ...formData, [name]: stringValue, suburb: '' });
        } else {
            setFormData({ ...formData, [name]: stringValue });
        }
    };
    const { RoleName, RoleID, nameidentifier: userID, FirstName } = useSelector((state: RootState) => state.adminAuth);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // useEffect(() => {
    //   console.log("RoleName:", RoleName);
    //   console.log("RoleId:", RoleID);
    //   console.log("UserID:", userID);
    //   console.log("FirstName:", FirstName);
    // }, [RoleName, userID, FirstName]);

    //Today I worked on fintrack do some update in property and kenket page and also update in database and do R&d about new work in property filter and emailed to the client Thanks

    const handleUpload = async () => {
        if (!selectedFile || !selectedPropertyId) {
            alert("Please select a PDF file first");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("PropertyId", String(selectedPropertyId)); // 👈 ID
            formData.append("BrochureFile", selectedFile);             // 👈 file
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
             const token = localStorage.getItem('crmtoken');
            const response = await fetch(`${baseUrl}/api/Property/upload-brochure`, {
                method: "POST",
                 headers: {
                'Authorization': `Bearer ${token}`
            },
                body: formData,
            });

            if (response.ok) {
                toast.success("Brochure uploaded successfully!");
                setIsModalOpen(false);
                setSelectedFile(null);
                setSelectedPropertyId(null);
                refetch(); // 👈 refresh table
            } else {
                toast.error("Failed to upload brochure.");
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Error uploading file.");
        }
    };


    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Download Excel Template
    const handleDownloadTemplate = () => {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const templateUrl = `${baseUrl}/Excel_Template/Excel_Template_Property.xlsx`;
        const link = document.createElement('a');
        link.href = templateUrl;
        link.download = 'Excel_Template_Property.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('Template downloaded successfully!');
    };

    // Handle Excel File Upload
    const handleExcelUpload = async () => {
        if (!selectedExcelFile) {
            toast.error('Please select an Excel file first');
            return;
        }

        setExcelUploadLoading(true);
       try {
        const formData = new FormData();
        formData.append('file', selectedExcelFile);
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const token = localStorage.getItem('crmtoken');

        const response = await fetch(`${baseUrl}/api/Property/upload_property-excel`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData,
        });

            if (response.ok) {
                const results = await response.json();
                setExcelUploadResults(results);
                setExcelUploadModal(false);
                setExcelResultModal(true);
                setSelectedExcelFile(null);
                refetch();
            } else {
                toast.error('Failed to upload Excel file');
            }
        } catch (error) {
            console.error('Excel upload error:', error);
            toast.error('Error uploading Excel file');
        } finally {
            setExcelUploadLoading(false);
        }
    };

    // Handle Excel Export with Supplier Filter
    const handleExcelExport = async () => {
        setExcelExportLoading(true);
        try {
            const supplierId = selectedSupplierForExport === '' || selectedSupplierForExport === '0'
                ? null
                : parseInt(selectedSupplierForExport);

            const response = await downloadPropertyExcel(supplierId);

            if (response.status === 200) {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                const contentDisposition = response.headers['content-disposition'];
                let filename = 'Properties_Export.xlsx';
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                }

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                toast.success('Excel file downloaded successfully!');
                setExcelExportModal(false);
                setSelectedSupplierForExport('');
            }
        } catch (error: any) {
            console.error('Excel export error:', error);

            if (error.response && error.response.status === 400) {
                toast.error(error.response.data.message || 'No data available for this supplier.');
            } else {
                toast.error('Error downloading Excel file');
            }
        } finally {
            setExcelExportLoading(false);
        }
    };



    const navigate = useSafeNavigate();

    const selectedArea: any = areasData.filter((area: any) => area.value == formData.area);
    const selectedSuburb: any = suburb.filter((area: any) => area.value == formData.suburb);
    const selectedSupplier: any = builders.filter((builder: any) => builder.value == formData.supplier);
    // Dynamic params object
    const params = {
        PageNumber: currentPage,
        PageSize: pageSize,
        PropertyType: formData.propType,
        Bedrooms: formData.minimumBed,
        Price: formData.maxPrice,
        MaximumPrice: formData.maxPrice,
        Suburb: selectedSuburb[0]?.value,
        SearchedLandSQM: formData.landSize,
        construction: formData.construction,
        ContractType: formData.contractType,
        Title: formData.titled,
        PropertyId: formData.propertyId,
        Supplier: selectedSupplier[0]?.value || "",
        stateid: formData.state,
        area: formData.area,
        propertyKenket: formData.propertyKenket ?? "2",
        PropertyName: "",
        yield: formData.yield
    };

    const {
        data: allPropertiesData,
        isLoading: allPropertiesLoading,
        isError: allPropertiesIsError,
        refetch
    } = useGetRequestQuery(
        ["getAllProperties", currentPage, pageSize, searchTrigger],
        () => GetAllpropertiesKenket(params as any),
        {
            enabled: true,
        }
    );


    useEffect(() => {
        if (allPropertiesData?.data && !allPropertiesIsError && !allPropertiesLoading) {
            setPropertiesData(allPropertiesData.data); // 👈 overwrite instead of append

            setHasMore(allPropertiesData.data.length === pageSize); // if less than 25, no more pages
        }

        if (allPropertiesData?.data?.length === 0 && currentPage === 1) {
            setPropertiesData([]);
            setHasMore(false);
        }

        // console.log('check property count', allPropertiesData?.data?.[0].totalCount);
    }, [allPropertiesData, allPropertiesIsError, allPropertiesLoading, currentPage]);

    // useEffect(() => {
    //     if (allPropertiesData?.data && !allPropertiesIsError && !allPropertiesLoading) {
    //         if (currentPage === 1) {
    //             // 👇 fresh search → overwrite
    //             setPropertiesData(allPropertiesData.data);
    //         } else {
    //             // 👇 infinite scroll → append
    //             setPropertiesData((prev: any) => {
    //                 const existingIds = new Set(prev.map((p: any) => p.propertyId));
    //                 const uniqueNew = allPropertiesData.data.filter((p: any) => !existingIds.has(p.propertyId));
    //                 return [...prev, ...uniqueNew];
    //             });
    //         }

    //         if (allPropertiesData.data.length < pageSize) {
    //             setHasMore(false);
    //         }
    //     }

    //     if (allPropertiesData?.data?.length === 0 && currentPage === 1) {
    //         setPropertiesData([]); // no results
    //         setHasMore(false);
    //     }
    // }, [allPropertiesData, allPropertiesIsError, allPropertiesLoading, currentPage]);
    // useEffect(() => {
    //     if (allPropertiesData?.data && !allPropertiesIsError && !allPropertiesLoading) {
    //         setPropertiesData(allPropertiesData?.data);
    //     }
    // }, [allPropertiesData, allPropertiesIsError, allPropertiesLoading]);
    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (
    //             window.innerHeight + document.documentElement.scrollTop + 100 >=
    //             document.documentElement.offsetHeight
    //         ) {
    //             if (hasMore && !allPropertiesLoading) {
    //                 setCurrentPage((prev) => prev + 1);
    //             }
    //         }
    //     };

    //     window.addEventListener("scroll", handleScroll);
    //     return () => window.removeEventListener("scroll", handleScroll);
    // }, [hasMore, allPropertiesLoading]);

    const { data: buildersData, isLoading: buildersLoading, isError: buildersIsError } = useGetRequestQuery<any>(
        ['getAllBuilders'],
        getAllBuildersService,
        { enabled: true }
    );
    useEffect(() => {
        if (buildersData?.data && !buildersIsError && !buildersLoading) {
            const transformedData = buildersData.data
                .filter((builder: any) => builder.isActive === true || builder.isActive === 1)
                .map((builder: any) => ({
                    value: builder.supplierId,
                    label: builder.supplier
                }));
            setBuilders(transformedData);
        }
    }, [buildersData, buildersIsError, buildersLoading]);

    const {
        data: allStatesData,
        isLoading: allStatesLoading,
        isError: allStatesIsError,
    } = useGetRequestQuery(
        ["getAllStates"],
        getAllStates,
        {
            enabled: true,
        }
    );
    useEffect(() => {
        if (allStatesData?.data && !allStatesIsError && !allStatesLoading) {
            const transformedData = allStatesData.data.map((state: any) => ({
                value: state.id,
                label: state.name
            }));
            setStatesData(transformedData);
        }
    }, [allStatesData, allStatesIsError, allStatesLoading]);

    const {
    data: allAreasData,
    isLoading: allAreasLoading,
    isError: allAreasIsError,
} = useGetRequestQuery(
    ["getAllAreas", formData.state],        // state change hote hi refetch
    () => getAllAreas({
        searchId: formData.state || "0",    // state select nahi toh sab, select toh us state ka
        searchType: "area"
    }),
    {
        enabled: true,                      // state select se pehle bhi data aaye (sab areas)
    }
);

    useEffect(() => {
        // if (allAreasData?.data && !allAreasIsError && !allAreasLoading) {
        //     const transformedData = allAreasData?.data?.map((area: any) => ({
        //         value: area.id,
        //         label: area.name
        //     }));

        //     setAreasData(transformedData);
        // }


        if (allAreasData?.data && !allAreasIsError && !allAreasLoading) {
            const transformedData = allAreasData.data
                .map((area: any) => ({
                    value: area.id,
                    label: area.name
                }))
                .sort((a: any, b: any) => a.label.localeCompare(b.label)); // <-- Sort alphabetically

            setAreasData(transformedData);
        }
    }, [allAreasData, allAreasIsError, allAreasLoading]);


   const {
    data: allSuburbsData,
    isLoading: allSuburbsLoading,
    isError: allSuburbsIsError,
} = useGetRequestQuery(
    ["getAllSuburbs", formData.area],       // area change hote hi refetch
    () => getAllAreas({
        searchId: formData.area || "0",     // area select nahi toh sab, select toh us area ke suburbs
        searchType: "suburb"
    }),
    {
        enabled: true,
    }
);
    useEffect(() => {
        if (allSuburbsData?.data && !allSuburbsIsError && !allSuburbsLoading) {
            const transformedSuburbsData = allSuburbsData.data
                .map((suburb: any) => ({
                    value: suburb.id,
                    label: suburb.name,
                }))
                .sort((a: any, b: any) => a.label.localeCompare(b.label));

            setSuburb(transformedSuburbsData);
        }
    }, [allSuburbsData, allSuburbsIsError, allSuburbsLoading]);

    const handleSearch = () => {
        setPropertiesData([]);
        setCurrentPage(1);       // 👈 page reset
        setHasMore(true);        // 👈 allow more data
        setSearchTrigger((prev) => prev + 1);
        setCheckedPropertyIds([]); // 👈 clear selections on new search

        window.scrollTo(0, 0);
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            if (file.type === "application/pdf") {
                setSelectedFile(file);
            } else {
                alert("Please upload a PDF file only.");
            }
        }
    };







    const exportToPDF = async () => {
        toast.info("Fetching all properties for PDF...", { autoClose: 2000 });

        const allPropertiesParams = {
            ...params,
            PageNumber: 1,
            PageSize: 2000
        };

        try {
            const allData = await GetAllpropertiesKenket(allPropertiesParams as any);
            const allProperties = allData?.data || [];

            const pdf = new jsPDF({ orientation: "landscape" });
            const logo = new Image();
            logo.src = "/assets/images/fintrack_logo.png";

            logo.onload = () => {
                const margin = 10;
                const logoWidth = 60;
                const logoHeight = 15;
                const logoX = margin;
                const logoY = margin;

                pdf.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

                const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "long", year: "numeric" };
                const currentDate = new Date().toLocaleDateString("en-GB", options);

                pdf.setFontSize(11);
                pdf.setTextColor(0, 0, 0);

                const dateText = `Date: ${currentDate}`;
                const dateX = pdf.internal.pageSize.width - margin - pdf.getTextWidth(dateText);
                const dateY = logoY + (logoHeight / 2) + 4;
                pdf.text(dateText, dateX, dateY);

                // Get filter labels with "ALL" for unselected
                const selectedStateName = statesData.find((s: any) => s.value == formData.state)?.label || 'ALL';
                const selectedAreaName = areasData.find((a: any) => a.value == formData.area)?.label || 'ALL';
                const selectedContractType = property.contractType.find((c: any) => c.value == formData.contractType)?.label || 'ALL';
                const selectedPropType = formData.propType || 'ALL';
                const selectedPrice = formData.maxPrice || 'ALL';

                // Build filter heading: State - Area - Contract Type - Property Type - Price
                const filterText = `${selectedStateName} - ${selectedAreaName} - ${selectedContractType} - ${selectedPropType} - ${selectedPrice}`;

                // Display filter heading and total properties below logo
                pdf.setFontSize(12);
                pdf.setTextColor(0, 0, 255); // Blue color
                const pageWidth = pdf.internal.pageSize.width;

                // Position filter text below the logo on the left
                const filterY = logoY + logoHeight + 5; // Below logo with 5 units gap
                pdf.text(filterText, margin, filterY);

                // Position total properties in the center
                const totalCountText = `Total Properties: ${allProperties.length}`;
                const totalTextWidth = pdf.getTextWidth(totalCountText);
                const totalX = (pageWidth - totalTextWidth) / 2; // Center position
                pdf.text(totalCountText, totalX, filterY);

                const lineY = filterY + 5;
                pdf.setDrawColor(0, 0, 255);
                pdf.line(margin, lineY, pdf.internal.pageSize.width - margin, lineY);

                const excelData = allProperties.map((row: any) => [
                    row.propertyId,
                    row.propertyType,
                    row.lotNumber,
                    row.estate,
                    row.propertyAddress,
                    row.suburb,
                    row.stateName,
                    row.areaName,
                    row.price1Bedroom,
                    row.rentYield ? `${row.rentYield}%` : '',
                    row.houseSize ? `${row.houseSize}` : '',
                    row.landSize ? `${row.landSize}` : '',
                    row.bedrooms,
                    row.titled
                ]);

                const headers = [
                    ["ID", "PropertyType", "Lot #", "Estate", "Address", "Suburb", "State", "Area", "Price", "Yield", "House", "Land", "Beds", "Titled"]
                ];

                autoTable(pdf, {
                    head: headers,
                    body: excelData,
                    startY: lineY + 5,
                    margin: { left: margin, right: margin },
                    styles: { cellPadding: 2, lineWidth: 0, fontSize: 8 },
                    headStyles: { fillColor: [0, 0, 255], textColor: 255, fontSize: 9 },
                });

                // Generate filename with filters and date
                const today = new Date();
                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const year = today.getFullYear();
                const dateStr = `${day}/${month}/${year}`;

                let filename = "Property_List";
                const filenameParts = [];
                if (selectedStateName) filenameParts.push(selectedStateName);
                if (selectedAreaName) filenameParts.push(selectedAreaName);
                if (selectedPropType) filenameParts.push(selectedPropType);
                if (selectedContractType) filenameParts.push(selectedContractType);
                if (selectedPrice) filenameParts.push(selectedPrice);

                if (filenameParts.length > 0) {
                    filename += "_" + filenameParts.join("_");
                }

                filename += `_${dateStr.replace(/\//g, '-')}.pdf`;

                pdf.save(filename);
                toast.success("PDF generated successfully!");
            };

            logo.onerror = () => {
                console.error("Error loading the logo image.");
                toast.error("Error loading logo.");
            };
        } catch (error) {
            console.error("Error fetching all properties:", error);
            toast.error("Failed to fetch all properties for PDF.");
        }
    };

    const { mutate: softDeleteProperty, isPending: isSoftDeletePending } = useMutationRequestQuery(
        "softDeleteProperty",
        softDeletePropertyService,
        {
            onSuccess: () => {
                toast.success("Properties deleted successfully.");
                refetch();
                setDeleteModal(false);
                setCheckedPropertyIds([]);
            },
            onError: () => {
                toast.error("Failed to delete properties.");
                setDeleteModal(false);
            },
        }
    );

    const confirmDeleteProperty = () => {
        setDeleteModal(true);
    };

    const handleDeletePropertyClick = () => {
        softDeleteProperty(selectedLeadsId);
    };


    const selectRow = {
        mode: "checkbox",
        hideSelectAll: true,
        selected: selectedLeadsId,
        clickToSelect: false,
        selectColumnPosition: 'right',
        selectColumnStyle: { marginRight: "10px" },
        onSelect: (row: any, isSelect: boolean) => {
            setCheckedPropertyIds((prev: any[]) =>
                isSelect
                    ? [...prev, row.propertyId]
                    : prev.filter(id => id !== row.propertyId)
            );
        },
        // nonSelectable: propertiesData
        //     // .filter((row: any) => row.propertyKenket === 1)
        //     .map((row: any) => row.propertyId), // 👈 Disable selection for these rows
        //       onSelect: (row: any, isSelect: boolean) => {
        //     setCheckedPropertyIds((prevSelected: any) =>
        //         isSelect
        //             ? [...prevSelected, row.propertyId]
        //             : prevSelected.filter((id: any) => id !== row.propertyId)
        //     );
        // },
        onSelectAll: (isSelect: boolean, rows: any[]) => {
            const ids = rows.map(r => r.propertyId);
            setCheckedPropertyIds((prev: any[]) => {
                if (isSelect) {
                    return Array.from(new Set([...prev, ...ids]));
                } else {
                    return prev.filter(id => !ids.includes(id));
                }
            });
        }
    };



    useEffect(() => {
        if (selectedFlyer && Object.keys(selectedFlyer).length > 0) {
            generatePDF();
        }
    }, [selectedFlyer]);

    useEffect(() => {
        if (selectedPackage && Object.keys(selectedPackage).length > 0) {
            generatePackagePDF();
        }
    }, [selectedPackage]);


    const generatePDF = async () => {
        if (!selectedFlyer) return;

        const htmlContent = await PropertyFlyer(selectedFlyer);

        // Create an off-screen container
        const hiddenElement = document.createElement("div");
        hiddenElement.style.width = "800px";
        hiddenElement.style.padding = "20px";
        hiddenElement.style.backgroundColor = "white";
        hiddenElement.style.fontFamily = "Arial, sans-serif";
        hiddenElement.style.position = "absolute";
        hiddenElement.style.left = "-9999px";
        hiddenElement.innerHTML = htmlContent;

        document.body.appendChild(hiddenElement);

        const canvas = await html2canvas(hiddenElement, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: true,
            imageTimeout: 15000
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        // pdf.save(`property-details-${selectedFlyer.propertyId}.pdf`);
        pdf.save(`$${selectedFlyer.price1Bedroom} - ID ${selectedFlyer.propertyId} - ${selectedFlyer.lotNumber} - ${selectedFlyer.suburb} - ${selectedFlyer.stateName}.pdf`);
        document.body.removeChild(hiddenElement);
    };

    // const generatePDF = async () => {
    //     if (!selectedFlyer) return;

    //     const htmlContent = PropertyFlyer(selectedFlyer);

    //     const newWindow = window.open("", "_blank");
    //     if (!newWindow) {
    //         alert("Please enable pop-ups in your browser.");
    //         return;
    //     }

    //     newWindow.document.write(`
    //         <html>
    //             <head>
    //                 <title>Property Flyer</title>
    //                 <style>
    //                     body {
    //                         font-family: Arial, sans-serif;
    //                         padding: 20px;
    //                         background-color: white;
    //                         margin: 0;
    //                     }
    //                     img {
    //                         max-width: 100%;
    //                         height:350px;
    //                     }
    //                     /* Scale everything down to fit one page */
    //                     @media print {
    //                         body {
    //                             transform-origin: top center;
    //                             transform: scale(0.8); /* adjust scale to fit */
    //                             width: 100vw;
    //                             height: 100vh;
    //                             overflow: hidden;
    //                         }
    //                         /* Remove default margins to use full page */
    //                         @page {
    //                             margin: 0;
    //                         }
    //                     }
    //                 </style>
    //             </head>
    //             <body>
    //                 ${htmlContent}
    //             </body>
    //         </html>
    //     `);
    //     newWindow.document.close();

    //     newWindow.onload = () => {
    //         newWindow.focus();
    //         newWindow.print();
    //         // newWindow.close();
    //     };
    // };


    const generatePackagePDF = async () => {
        setLoading(true);
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;

        const addHtmlToPdf = async (htmlContent: any, isFirstPage = false) => {
            const hiddenElement = document.createElement("div");
            hiddenElement.style.width = "800px";
            hiddenElement.style.padding = "20px";
            hiddenElement.style.backgroundColor = "white";
            hiddenElement.style.fontFamily = "Arial, sans-serif";
            hiddenElement.style.position = "absolute";
            hiddenElement.style.left = "-9999px";
            hiddenElement.style.overflow = "visible";
            hiddenElement.innerHTML = htmlContent;

            // Convert all images to base64 before rendering
            const images = Array.from(hiddenElement.getElementsByTagName('img'));
            for (let img of images) {
                if (img.src && !img.src.startsWith('data:')) {
                    try {
                        const base64 = await getBase64FromUrl(img.src);
                        img.src = base64;
                    } catch (error) {
                        console.error('Error converting image to base64:', error);
                        img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
                    }
                }
            }

            document.body.appendChild(hiddenElement);

            const canvas = await html2canvas(hiddenElement, {
                scale: 2.0,
                useCORS: true,
                allowTaint: true,
                logging: false,
                imageTimeout: 15000,
                windowWidth: 800
            });

            const imgData = canvas.toDataURL("image/jpeg", 0.85);
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            if (!isFirstPage) pdf.addPage();
            pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

            document.body.removeChild(hiddenElement);
        };

        try {
            // Await all async components
            const [
                packageHtml,
                stateReportHtml,
                companyProfileHtml,
                floorplanHtml,
                estateImagesHtml,
                inclusionsHtml,
                RentAppraisalHtml,
                contactUsHtml,
            ] = await Promise.all([
                PackageDownload(selectedPackage),
                StateReport(),
                CompanyProfile(),
                Floorplan(selectedPackage),
                EstateAndSubdivisionImages(selectedPackage),
                Inclusions(selectedPackage),
                RentAppraisal(selectedPackage),
                ContactUsSection()
            ]);

            // Add each page to the PDF
            await addHtmlToPdf(packageHtml, true);
            // await addHtmlToPdf(stateReportHtml);
            await addHtmlToPdf(companyProfileHtml);
            await addHtmlToPdf(floorplanHtml);
            await addHtmlToPdf(estateImagesHtml);
            await addHtmlToPdf(inclusionsHtml);
            await addHtmlToPdf(RentAppraisalHtml);
            await addHtmlToPdf(contactUsHtml);

            // Convert PDF to Blob
            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);

            // Open in new tab with property ID and package name in filename
            // const fileName = `Property-${selectedPackage.propertyId}-Package.pdf`;
            const fileName = `$${selectedPackage.price1Bedroom} - ID ${selectedPackage.propertyId} - ${selectedPackage.lotNumber} - ${selectedPackage.suburb} - ${selectedPackage.stateName}.pdf`;
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(pdfUrl);

            setLoading(false);
        } catch (error) {
            console.error('Error generating PDF:', error);
            setLoading(false);
            toast.error('Failed to generate PDF');
        }
    };
    useEffect(() => {
        if (loading) {
            toast.info("Generating PDF, please wait...", {
                autoClose: 2000,
                closeButton: true,
            });
        }
    }, [loading]);




    const sortedPropertiesData = propertiesData;
    const propertyColumns = [
        { dataField: "propertyId", text: "ID", headerStyle: { fontSize: "13px", width: "2rem", color: "#0000ff" }, style: { fontSize: "13px", } },
        { dataField: "stateName", text: "State", headerStyle: { fontSize: "13px", color: "#0000ff" } },
        { dataField: "supplierName", text: "Builder", headerStyle: { fontSize: "13px", color: "#0000ff" } },
        { dataField: "propertyType", text: "Property Type", headerStyle: { fontSize: "13px", width: "12rem", color: "#0000ff" }, style: { fontSize: "13px", } },
        { dataField: "lotNumber", text: "Lot", headerStyle: { color: "#0000ff" }, style: { fontSize: "13px", } },

        { dataField: "propertyAddress", text: "Address", headerStyle: { fontSize: "13px", width: "12rem", color: "#0000ff" }, style: { fontSize: "13px", } },
        // { dataField: "estate", text: "Estate", headerStyle: { fontSize: "13px",color: "#0000ff" } ,style: {  fontSize: "13px", }},
        { dataField: "suburb", text: "Suburb", headerStyle: { fontSize: "13px", color: "#0000ff" }, style: { fontSize: "13px", } },
        {
            dataField: "price1Bedroom",
            text: "Price",
            // formatter: (cell: any) => (cell ? `${cell}` : "$0"),
            formatter: (cell: any) => cell ? (cell.toString().includes('$') ? cell : `$${cell}`) : "$0",

            headerStyle: { fontSize: "13px", width: "7rem", color: "#0000ff" }, style: { fontSize: "13px", }
        },
        // {
        //
        //     dataField: "landPrice",
        //     text: "Land",
        //     formatter: (cell: any) => (cell ? `${cell}` : "$0"),
        //     headerStyle: { width: "7rem", color: "#0000ff" },style: {  fontSize: "13px", }
        // },
        // {
        //     dataField: "growthRating",
        //     text: "Growth",
        //     formatter: (cell: any) => (cell ? `${cell}` : " "),
        //     headerStyle: { width: "7rem", color: "#0000ff" },style: {  fontSize: "13px", }
        // },
        {
            dataField: "rentYield",
            text: "Yield",
            headerStyle: { fontSize: "13px", width: "6rem", color: "#0000ff" }, style: { fontSize: "13px", },
            // formatter: (cell: any) => `${cell} ${cell ? "" : ''}`
            formatter: (cell: any) => {
                // Remove all % characters from the string
                const cleanValue = cell?.toString().replace(/%/g, '');
                return `${cleanValue}`;
            }
        },
        {
            dataField: "houseSize",
            text: "House",
            headerStyle: { fontSize: "13px", width: "5rem", color: "#0000ff" }, style: { fontSize: "13px", },
            // formatter: (cell: any) => `${cell} ${cell ? "" : ''}`
            formatter: (cell: any) => {
                const value = parseFloat(cell);
                return isNaN(value) ? '' : Math.round(value).toString();
            }
        },
        {
            dataField: "landSize",
            text: "Land",
            headerStyle: { fontSize: "13px", width: "5rem", color: "#0000ff" }, style: { fontSize: "13px", },
            // formatter: (cell: any) => `${cell} ${cell ? "" : ''}`
            formatter: (cell: any) => {
                const value = parseFloat(cell);
                return isNaN(value) ? '' : Math.round(value).toString();
            }
        },
        { dataField: "bedrooms", text: "Beds", headerStyle: { fontSize: "13px", width: "5rem", color: "#0000ff" }, style: { fontSize: "13px", } },

        { dataField: "titled", text: "Titled", headerStyle: { fontSize: "13px", width: "7rem", color: "#0000ff" }, style: { fontSize: "13px", } },
        //         {
        //             dataField: "actions",
        //             text: (
        //                 <>
        //                     <span>Action</span>
        //                     {/* {RoleName !== 'Viewer' && (
        //   <button onClick={handleClick}>
        //     Submit
        //   </button>
        // )} */}
        //                     {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (
        //                         <Button color="danger" style={{ marginLeft: "10px" }} onClick={() => confirmDeleteProperty()}>
        //                             Delete
        //                         </Button>
        //                     )}
        //                 </>
        //             ),
        //             formatter: (_: any, row: any) => {
        //                 // Check if all five images are uploaded
        //                 const allImagesUploaded =
        //                     row.subdivisionImage ||
        //                     row.builderFaçadePageimage ||
        //                     row.floorPlanimage ||
        //                     row.inclusionsimage ||
        //                     row.ndiSimage ||
        //                     row.estateimage;

        //                 return (
        //                     <ul className="action simple-list d-flex flex-row align-items-center">
        //                         {(RoleID === '1' || RoleID === '4' || RoleID === '5') && (
        //                             <li style={{ cursor: "pointer" }} className="delete">
        //                                 <Link style={{ marginRight: "10px" }} className="primary" to={`/EditProperty/${row.propertyId}`}>
        //                                     Edit |
        //                                 </Link>
        //                             </li>

        //                         )}
        //                         {/* <span style={{ color: 'blue' }}> |</span> */}

        //                         <li
        //                             style={{ cursor: "pointer", marginLeft: '10px' }}
        //                             onClick={() => { setSelectedFlyer(row) }}
        //                             className="edit"
        //                         >
        //                             <a className="primary">Flyer</a>
        //                         </li>
        //                         <span style={{ color: 'blue' }}> |</span>

        //                         {allImagesUploaded && (
        //                             <>
        //                                 <li
        //                                     style={{ cursor: "pointer", marginLeft: '10px', marginRight: '10px' }}
        //                                     className="delete"
        //                                 >
        //                                     <span className="primary" style={{ color: 'var(--theme-default)' }} onClick={() => setSelectedPackage(row)}>
        //                                         Package
        //                                     </span>
        //                                 </li>
        //                                 <span style={{ color: 'blue' }}> |</span>
        //                             </>
        //                         )}

        //                         <>

        //                             {/* <li
        //                                     style={{ cursor: "pointer", marginLeft: '10px', marginRight: '10px' }}
        //                                     className="delete"  
        //                                 >
        //                                          Upload
        //                                  </li>
        //                                 <span style={{ color: 'blue' }}> |</span> */}

        //                             {



        //                                 !row.brochurepdf ? (



        //                                     <>
        //                                     {(RoleID === '1' || RoleID === '4' || RoleID === '5')&& (
        //                                         <li
        //                                             style={{ cursor: "pointer", color: 'blue', marginLeft: "10px", marginRight: "10px" }}
        //                                             onClick={() => {
        //                                                 setSelectedPropertyId(row.propertyId); // 👈 property id set karo
        //                                                 setIsModalOpen(true);                  // 👈 modal khol do
        //                                             }}
        //                                         >
        //                                             BROCHURE |
        //                                         </li> )}

        //                                         {/* <span style={{ color: "blue" }}> |</span> */}
        //                                     </>
        //                                 ) : (
        //                                     <>

        //                                         <li
        //                                             style={{ cursor: "pointer", marginLeft: '10px', marginRight: '10px', color: 'blue' }}
        //                                             className="download"
        //                                             onClick={() => {
        //                                                 const baseUrl = process.env.REACT_APP_API_BASE_URL;
        //                                                 const brochureUrl = `${baseUrl}/brochures/${row.brochurepdf}`;  // Construct full URL
        //                                                 const newTab = window.open(brochureUrl, '_blank');

        //                                                 if (!newTab) {
        //                                                     alert('Popup blocked! Please allow popups for this site.');
        //                                                 }
        //                                             }}
        //                                         >
        //                                             View PDF |
        //                                         </li>

        //                                         {/* <span style={{ color: 'blue' }}> |</span> */}
        //                                     </>
        //                                 )
        //                             }

        //                         </>





        //                         {/* Show "Yes" if all images are uploaded, otherwise "No" */}
        //                         {/* {allImagesUploaded ? (
        //                             <li style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
        //                                 <label htmlFor={`yes-${row.propertyId}`} style={{ color: "green", fontWeight: "bold" }}>Yes</label>
        //                             </li>
        //                         ) : (
        //                             <li style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
        //                                 <label htmlFor={`no-${row.propertyId}`} style={{ color: "red", fontWeight: "bold" }}>No</label>
        //                             </li>
        //                         )} */}
        //                     </ul>
        //                 );
        //             },
        //             headerStyle: { color: "#0000ff" },
        //         }


        {
            dataField: "actions",
            text: (
                <>
                    <span>Action</span>
                    {(RoleID === '1' || RoleID === '4' || RoleID === '5' || RoleID === '3') && (
                        <>
                            <Button
                                color="primary"
                                style={{ marginLeft: "10px" }}
                                onClick={() => {
                                    const allIds = sortedPropertiesData.map((row: any) => row.propertyId);
                                    setCheckedPropertyIds((prev: any[]) => {
                                        const allSelected = allIds.every((id: any) => prev.includes(id));
                                        if (allSelected) {
                                            return prev.filter((id: any) => !allIds.includes(id));
                                        } else {
                                            return Array.from(new Set([...prev, ...allIds]));
                                        }
                                    });
                                }}
                            >
                                {sortedPropertiesData.every((row: any) => selectedLeadsId.includes(row.propertyId)) ? 'Deselect All' : 'Select All'}
                            </Button>
                            <span style={{ marginLeft: "10px", fontWeight: "bold", color: "#0000ff" }}>
                                Selected: {selectedLeadsId.length}
                            </span>
                            <Button color="danger" style={{ marginLeft: "10px" }} onClick={() => confirmDeleteProperty()}>
                                Delete
                            </Button>
                        </>
                    )}
                </>
            ),
            formatter: (_: any, row: any) => {
                // 👇 If propertyKenket = 1, hide all actions
                // if (row.brochurepdf) {
                //     const baseUrl = process.env.REACT_APP_API_BASE_URL;
                //     const brochureUrl = `${row.brochurepdf}`;

                //     return (
                //         <ul className="action simple-list d-flex flex-row align-items-center">
                //             {/* View PDF - Modified to open modal */}
                //             <li
                //                 style={{
                //                     cursor: "pointer",
                //                     marginLeft: "10px",
                //                     marginRight: "10px",
                //                     color: "blue",
                //                 }}
                //                 onClick={() => {
                //                     setSelectedPropertyDetails(row);
                //                     setPropertyDetailsModal(true);
                //                 }}
                //             >
                //                 👁️ View
                //             </li>

                //             {/* Download PDF */}
                //             <li
                //                 style={{
                //                     cursor: "pointer",
                //                     marginLeft: "10px",
                //                     marginRight: "10px",
                //                     color: "green",
                //                 }}
                //             >
                //                 <a
                //                     href={brochureUrl}
                //                     target="_blank"

                //                     rel="noopener noreferrer"
                //                     download
                //                     style={{ color: "green", textDecoration: "none" }}
                //                 >
                //                     ⬇️ Brochure
                //                 </a>
                //             </li>
                //         </ul>
                //     );
                // }


                // ✅ Normal action buttons if propertyKenket = 0
                const allImagesUploaded =
                    row.subdivisionImage ||
                    row.builderFaçadePageimage ||
                    row.floorPlanimage ||
                    row.inclusionsimage ||
                    row.ndiSimage ||
                    row.estateimage;

                return (
                    <ul className="action simple-list d-flex flex-row align-items-center">
                        {(RoleID === '1' || RoleID === '4' || RoleID === '5' || RoleID === '3') && (
                            <li style={{ cursor: "pointer" }} className="delete">
                                <Link
                                    style={{ marginRight: "10px" }}
                                    className="primary"
                                    to={`/EditProperty/${row.propertyId}`}
                                >
                                    Edit |
                                </Link>
                            </li>
                        )}

                        <li
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                            onClick={() => setSelectedFlyer(row)}
                            className="edit"
                        >
                            <a className="primary">Flyer</a>
                        </li>
                        <span style={{ color: "blue" }}> |</span>

                        {allImagesUploaded && (
                            <>
                                <li
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                    }}
                                    className="delete"
                                >
                                    <span
                                        className="primary"
                                        style={{ color: "var(--theme-default)" }}
                                        onClick={() => setSelectedPackage(row)}
                                    >
                                        Package
                                    </span>
                                </li>
                                <span style={{ color: "blue" }}> |</span>
                            </>
                        )}

                        {!row.brochurepdf ? (
                            <>
                                {(RoleID === '1' || RoleID === '4' || RoleID === '5' || RoleID === '3') && (
                                    <li
                                        style={{
                                            cursor: "pointer",
                                            color: "blue",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                        }}
                                        onClick={() => {
                                            setSelectedPropertyId(row.propertyId);
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        BROCHURE |
                                    </li>
                                )}
                            </>
                        ) : (
                            <>
                                <li
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        color: "blue",
                                    }}
                                    className="download"
                                    onClick={() => {
                                        const baseUrl =
                                            process.env.REACT_APP_API_BASE_URL;
                                        const brochureUrl = `${baseUrl}/brochures/${row.brochurepdf}`;
                                        const newTab = window.open(brochureUrl, "_blank");
                                        if (!newTab) {
                                            alert(
                                                "Popup blocked! Please allow popups for this site."
                                            );
                                        }
                                    }}
                                >
                                    View PDF |
                                </li>
                            </>
                        )}
                    </ul>
                );
            },
            headerStyle: { color: "#0000ff" },
        }









        // {
        //     dataField: "",
        //     text: "",
        //     headerFormatter: () => (
        //         <div style={{ textAlign: "center" }}>
        //             <Button color="danger" onClick={() => confirmDeleteProperty()}>
        //                 Delete
        //             </Button>
        //         </div>
        //     ),
        //     formatter: () => null,
        //     headerStyle: { textAlign: "center" }
        // }

    ];
    return (
        <>
            {/* <div dangerouslySetInnerHTML={{ __html: CompanyProfile() }} /> */}


            <div className='container-fluid'>
                <div className="table-responsive h-100 py-4">
                    <section className='bg-white'>
                        <div className="scrollable-table-container">
                            <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <Col xs={3} className='d-flex'>
                                        <H3 className="heading-color f-w-900 text-left">Property Search</H3>
                                    </Col>
                                    <Col xs={3} className='d-flex justify-content-end'>
                                        <H3 className="heading-color f-w-900 text-center mb-0">Total Properties: {allPropertiesData?.data?.[0]?.totalCount ?? 0}</H3>
                                    </Col>
                                    <Col xs={6} className='d-flex justify-content-center gap-2'>
                                        {(RoleID === '1' || RoleID === '4' || RoleID === '5' || RoleID === '3') && (
                                            <>
                                                <Button color="success" size="sm" style={{ fontSize: '13px', marginLeft: '10rem' }} onClick={() => setExcelUploadModal(true)}>Import Excel</Button>


                                                <Button color="info" size="sm" style={{ fontSize: '13px' }} onClick={() => setExcelExportModal(true)}>Export Excel</Button>
                                                <Button color="warning" size="sm" style={{ fontSize: '13px' }} onClick={handleDownloadTemplate}>Download Template</Button>

                                            </>
                                        )}
                                    </Col>
                                </div>


                                <Row className='mt-4'>
                                    <div className='d-flex item-center mt-2'>
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Property ID:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <TextField
                                                label=""
                                                type="text"
                                                name="propertyId"
                                                value={formData.propertyId}
                                                setValue={handleValueChange}
                                                placeholder=""
                                                design="flex"
                                                passCol='col-10'
                                                maxChars={6}
                                                tabIndex={1}
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">State:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="state"
                                                value={formData.state}
                                                setValue={handleValueChange}
                                                options={statesData || []}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Highest Yield:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="yield"
                                                value={formData.yield}
                                                setValue={handleValueChange}
                                                options={property.yield}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Minimum Bed:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="minimumBed"
                                                value={formData.minimumBed}
                                                setValue={handleValueChange}
                                                options={property.minimumBed}
                                                required={true}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Button onClick={handleSearch} size="sm" style={{ marginBottom: '16px', fontSize: '15px', width: '10%' }} className="text-center" color="success" >
                                            Search Now
                                        </Button>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Max Price:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="maxPrice"
                                                value={formData.maxPrice}
                                                setValue={handleValueChange}
                                                options={property.maxPrice}
                                                tabIndex={1}
                                                passCol="col-10"
                                            />
                                        </Col>

                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Area:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="area"
                                                value={formData.area}
                                                setValue={handleValueChange}
                                                options={areasData || []}
                                                tabIndex={2}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Titled:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="titled"
                                                value={formData.titled}
                                                setValue={handleValueChange}
                                                options={property.titled}
                                                tabIndex={3}
                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Contract Type:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="contractType"
                                                value={formData.contractType}
                                                setValue={handleValueChange}
                                                options={property.contractType}
                                                tabIndex={4}
                                                passCol="col-10"
                                            />
                                        </Col>

                                        {(RoleID === '1' || RoleID === '4' || RoleID === '5' || RoleID === '3') && (
                                            <Button color="primary" size="sm" style={{ marginBottom: '14px', fontSize: '15px', width: '10%' }} onClick={() => navigate("/AddProperty")}>Add Property</Button>
                                        )}
                                    </div>

                                    {/* Third Row */}
                                    <div className="d-flex align-items-center">
                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Prop Type:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <Dropdown
                                                label=""
                                                name="propType"
                                                value={formData.propType}
                                                setValue={handleValueChange}
                                                options={property.propType}
                                                tabIndex={5}
                                                passCol="col-10"
                                            />
                                        </Col>




                                        <Col className="responsive-col" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Suburb:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="suburb"
                                                value={formData.suburb}
                                                setValue={handleValueChange}
                                                options={[...suburb].sort((a, b) => a.label.localeCompare(b.label))}
                                                tabIndex={6}
                                                passCol="col-10"
                                            />
                                        </Col>














                                        {/* 
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Land Size:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="landSize"
                                                value={formData.landSize}
                                                setValue={handleValueChange}
                                                options={property.landSize}
                                                tabIndex={7}
                                                passCol="col-10"
                                            />
                                        </Col> */}
                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Construction:</Label>
                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>


                                            <Dropdown
                                                label=""
                                                name="construction"
                                                // options={["To be constructed", "Near Completion", "Established"]}
                                                options={["All", "To be constructed", "Near Completion", "Completed"]}

                                                value={formData.construction}
                                                setValue={handleValueChange}
                                                tabIndex={7}

                                                passCol="col-10"
                                            />
                                        </Col>


                                        <Col className="responsive-col" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Builder:</Label>

                                        </Col>
                                        <Col className="responsive-col" xs={12} style={{ width: '14%', paddingInline: '2px' }}>
                                            <DropdownWithValueName
                                                label=""
                                                name="supplier"
                                                options={builders}
                                                value={formData.supplier}
                                                setValue={handleValueChange}
                                                tabIndex={7}

                                                passCol="col-10"
                                            />
                                        </Col>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={exportToPDF}
                                            disabled={propertiesData.length === 0}
                                            style={{ marginBottom: '14px', fontSize: '15px', width: '10%' }}
                                        >
                                            Property List
                                        </Button>
                                    </div>
                                    {/* <div className="d-flex align-items-center">

                                        <Col className="responsive-col" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                            <Label className="mb-3">Source:</Label>

                                        </Col>
                                        <Col
                                            className="responsive-col"
                                            xs={12}
                                            style={{ width: '14%', paddingInline: '2px' }}
                                        >
                                            <DropdownWithValueName
                                                label=""
                                                name="propertyKenket"
                                                value={formData.propertyKenket}
                                                setValue={handleValueChange}
                                                options={[
                                                    // { label: "Both", value: "2" },        // default → both tables
                                                    { label: "Old Properties", value: "0" }, // tbl_Properties
                                                    { label: "New Properties", value: "1" }  // PropertyDetailsKenket
                                                ]}

                                                required={false}
                                                tabIndex={6}
                                                passCol="col-10"
                                            />
                                        </Col>
                                    </div> */}
                                </Row>
                            </table>
                        </div>
                    </section>
                </div>
                {propertiesData.length !== 0 ? (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "5px",
                            backgroundColor: "#fff",
                            overflowX: "auto",
                            width: "100%",
                        }}
                        className="mb-4"
                    >
                        <div style={{ minWidth: "max-content" }}>
                            {/* <BootstrapTable
                                keyField="propertyId"
                                // data={propertiesData}
                                data={sortedPropertiesData}

                                columns={propertyColumns as any}
                                selectRow={selectRow as any}
                                bordered={false}
                                wrapperClasses="table-responsive"
                            /> */}

                            {/*  */}

                            <BootstrapTable
                                keyField="propertyId"
                                data={sortedPropertiesData}
                                columns={propertyColumns as any}
                                selectRow={selectRow as any}
                                bordered={false}
                                wrapperClasses="table-responsive"

                            />
                            <div
                                className="d-flex justify-content-between align-items-center mt-3"
                                style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}
                            >
                                {/* Previous */}
                                <Button
                                    color="secondary"
                                    disabled={currentPage === 1 || allPropertiesLoading}
                                    onClick={() => setCurrentPage((prev) => prev - 1)}
                                >
                                    Previous
                                </Button>

                                {/* Page numbers */}
                                <div className="d-flex gap-2">
                                    {(() => {
                                        const totalCount = allPropertiesData?.data?.[0]?.totalCount || 0;
                                        const totalPages = Math.ceil(totalCount / 25);
                                        const pages = [];

                                        if (totalPages <= 5) {
                                            for (let i = 1; i <= totalPages; i++) pages.push(i);
                                        } else {
                                            if (currentPage <= 3) {
                                                pages.push(1, 2, 3, '...', totalPages);
                                            } else if (currentPage >= totalPages - 2) {
                                                pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
                                            } else {
                                                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
                                            }
                                        }

                                        return pages.map((page, index) =>
                                            page === '...' ? (
                                                <span key={index} className="align-self-center px-2">...</span>
                                            ) : (
                                                <Button
                                                    key={page}
                                                    color={currentPage === page ? "primary" : "light"}
                                                    disabled={allPropertiesLoading}
                                                    onClick={() => setCurrentPage(page as number)}
                                                >
                                                    {page}
                                                </Button>
                                            )
                                        );
                                    })()}
                                </div>

                                {/* Next */}
                                <Button
                                    color="primary"
                                    disabled={!hasMore || allPropertiesLoading}
                                    onClick={() => setCurrentPage((prev) => prev + 1)}
                                >
                                    Next
                                </Button>
                            </div>



                            {allPropertiesLoading && (
                                <div style={{ textAlign: "center", padding: "10px" }}>
                                    <Spinner color="primary" />
                                </div>
                            )}

                            {!hasMore && !allPropertiesLoading && (
                                <div style={{ textAlign: "center", padding: "10px" }}>
                                    {/* <b>No more data</b> */}
                                </div>
                            )}

                        </div>
                    </div>
                ) : allPropertiesLoading ? (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "12px",
                            backgroundColor: "#fff",
                            textAlign: "center",
                        }}
                        className="mt-4 mb-2"
                    >
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <div
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            padding: "12px",
                            backgroundColor: "#fff",
                            textAlign: "center",
                        }}
                        className="mt-4 mb-2"
                    >
                        <h6>No properties data available.</h6>
                    </div>
                )}
            </div>
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} centered>
                <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>Confirm Delete</ModalHeader>
                <ModalBody>Are you sure you want to delete these properties ?</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                    <Button color="danger" onClick={handleDeletePropertyClick} disabled={isSoftDeletePending}>
                        {isSoftDeletePending ? "Deleting..." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} centered>
                <ModalHeader toggle={() => setIsModalOpen(false)}>Upload Brochure</ModalHeader>
                <ModalBody>
                    <input
                        type="file"
                        accept="application/pdf"
                        onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                                const file = e.target.files[0];
                                if (file.type === "application/pdf") {
                                    setSelectedFile(file);
                                } else {
                                    alert("Please upload only PDF file");
                                }
                            }
                        }}
                    />

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleUpload}>Upload</Button>
                    <Button color="secondary" onClick={() => setIsModalOpen(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={propertyDetailsModal} toggle={() => setPropertyDetailsModal(!propertyDetailsModal)} size="lg">
                <ModalHeader toggle={() => setPropertyDetailsModal(!propertyDetailsModal)}>
                    Property Details
                </ModalHeader>
                <ModalBody>
                    {selectedPropertyDetails && (
                        <div className="property-details">
                            <Row>
                                <Col md="6">
                                    <h5>Basic Information</h5>
                                    <p><strong>Property ID:</strong> {selectedPropertyDetails.propertyId}</p>
                                    <p><strong>Address:</strong> {selectedPropertyDetails.propertyAddress}</p>
                                    <p><strong>Lot Number:</strong> {selectedPropertyDetails.lotNumber}</p>
                                    <p><strong>Suburb:</strong> {selectedPropertyDetails.suburb}</p>
                                    <p><strong>State:</strong> {selectedPropertyDetails.stateName}</p>
                                    <p><strong>Estate:</strong> {selectedPropertyDetails.estate}</p>
                                </Col>
                                <Col md="6">
                                    <h5>Property Specifications</h5>
                                    <p><strong>Property Type:</strong> {selectedPropertyDetails.propertyType}</p>
                                    <p><strong>Price:</strong> ${selectedPropertyDetails.price1Bedroom}</p>
                                    <p><strong>Bedrooms:</strong> {selectedPropertyDetails.bedrooms}</p>
                                    <p><strong>House Size:</strong> {selectedPropertyDetails.houseSize}</p>
                                    <p><strong>Land Size:</strong> {selectedPropertyDetails.landSize}</p>
                                    <p><strong>Yield:</strong> {selectedPropertyDetails.rentYield}</p>
                                    <p><strong>Titled:</strong> {selectedPropertyDetails.titled}</p>
                                </Col>
                            </Row>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    {selectedPropertyDetails && selectedPropertyDetails.brochurepdf && (
                        <Button
                            color="primary"
                            onClick={() => window.open(selectedPropertyDetails.brochurepdf, "_blank")}
                        >
                            Open Brochure
                        </Button>
                    )}
                    <Button color="secondary" onClick={() => setPropertyDetailsModal(!propertyDetailsModal)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Excel Upload Modal */}
            <Modal isOpen={excelUploadModal} toggle={() => setExcelUploadModal(!excelUploadModal)} centered>
                <ModalHeader toggle={() => setExcelUploadModal(!excelUploadModal)} style={{ color: 'blue' }}>Upload Excel File With Property Data</ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <Label>Choose Excel File</Label>
                        <input
                            type="file"
                            className="form-control"
                            accept=".xlsx,.xls"
                            onChange={(e) => {
                                if (e.target.files && e.target.files[0]) {
                                    setSelectedExcelFile(e.target.files[0]);
                                }
                            }}
                        />
                        {selectedExcelFile && (
                            <small className="text-success mt-2 d-block">
                                Selected: {selectedExcelFile.name}
                            </small>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={handleExcelUpload}
                        disabled={!selectedExcelFile || excelUploadLoading}
                    >
                        {excelUploadLoading ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Uploading...
                            </>
                        ) : (
                            'Upload'
                        )}
                    </Button>
                    <Button color="secondary" onClick={() => setExcelUploadModal(!excelUploadModal)} disabled={excelUploadLoading}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Excel Results Modal */}
            <Modal isOpen={excelResultModal} toggle={() => setExcelResultModal(!excelResultModal)} size="xl">
                <ModalHeader toggle={() => setExcelResultModal(!excelResultModal)}>
                    Excel Upload Results
                </ModalHeader>
                <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {excelUploadResults.length > 0 ? (
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>Row #</th>
                                        <th>Unique ID</th>
                                        <th>Address</th>
                                        <th>Supplier</th>
                                        <th>State</th>
                                        <th>Suburb</th>
                                        <th>Status</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelUploadResults.map((result, index) => (
                                        <tr key={index} className={result.status === 'FAILED' ? 'table-danger' : result.status === 'UPDATED' ? 'table-success' : 'table-info'}>
                                            <td>{result.rowNo}</td>
                                            <td><strong>{result.uniqueId}</strong></td>
                                            <td>{result.propertyAddress}</td>
                                            <td>{result.supplier}</td>
                                            <td>{result.stateName}</td>
                                            <td>{result.suburbName}</td>
                                            <td>
                                                <span className={`badge ${result.status === 'FAILED' ? 'bg-danger' : result.status === 'UPDATED' ? 'bg-success' : 'bg-info'}`}>
                                                    {result.status}
                                                </span>
                                            </td>
                                            <td>{result.message}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="mt-3">
                                <h4 style={{ color: 'blue' }}><strong>Summary:</strong></h4>
                                <p><strong>Total Properties:</strong> {excelUploadResults.length}</p>
                                <p><strong>Success:</strong> <span className="text-success">{excelUploadResults.filter(r => r.status === 'UPDATED').length}</span></p>
                                <p><strong>Failed:</strong> <span className="text-danger">{excelUploadResults.filter(r => r.status === 'FAILED').length}</span></p>
                            </div>
                        </div>
                    ) : (
                        <p>No results to display</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setExcelResultModal(!excelResultModal)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Export Excel Modal */}
            <Modal isOpen={excelExportModal} toggle={() => setExcelExportModal(!excelExportModal)} size="md">
                <ModalHeader toggle={() => setExcelExportModal(!excelExportModal)}>
                    Export Properties to Excel
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <Label>Select Supplier</Label>
                            <DropdownWithValueName
                                label=""
                                name="supplierForExport"
                                value={selectedSupplierForExport}
                                setValue={(name, value) => setSelectedSupplierForExport(String(value))}
                                options={[
                                    // { value: '0', label: 'All Suppliers' },
                                    ...builders
                                ]}
                                required={false}
                                passCol="col-12"
                            />
                            <small className="text-muted">Select "All Suppliers" to export all properties or choose a specific supplier</small>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={handleExcelExport}
                        disabled={excelExportLoading}
                    >
                        {excelExportLoading ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Downloading...
                            </>
                        ) : (
                            'Download Excel'
                        )}
                    </Button>
                    <Button color="secondary" onClick={() => {
                        setExcelExportModal(false);
                        setSelectedSupplierForExport('');
                    }}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    );
}